import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type VehicleDetailResponse = {
  org: string
  clientId: string
}

export const useGetVehicleDetail = (vehicleId: string) => {
  return useQuery({
    queryKey: ['engagement', 'vehicle-detail', vehicleId],
    queryFn: async () => {
      const { data } = await apiClient.get<VehicleDetailResponse>(`/int/v3/vehicles/${vehicleId}`)
      return data
    },
  })
}
